import React, {useEffect} from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
function Footer() {

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div>
      <footer>

        <div data-aos-easing='ease-in-out'  data-aos='fade-up' className='hello'>
          <p>
            I'm Currently looking to join a team of creative designers
            and developers, If you think we might be the perfect
            fit for each other, send an Email.

          </p>
          <button className='say'>

            <a
              target='_blank'
              rel='noreferrer'
              href='mailto:babsbright69@gmail.com'>
              GET IN TOUCH</a>
          </button>
          <h5>DESIGNED & DEVELOPED BY TOLULOPE BRIGHT &copy; 2022</h5>

        </div>
      </footer>
    </div>
  )
}

export default Footer
